export default __webpack_public_path__ + "static/media/human_abdomen.6b264111.png";